import { render, staticRenderFns } from "./SubmitH1DeclarationsModal.vue?vue&type=template&id=0eecfafd&scoped=true&"
import script from "./SubmitH1DeclarationsModal.vue?vue&type=script&lang=js&"
export * from "./SubmitH1DeclarationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eecfafd",
  null
  
)

export default component.exports